const sleep = async (sec: number) =>
	await new Promise((r) => setTimeout(r, sec * 1000));

export { sleep };
